import { useContext } from 'react';
import SupportContext from 'src/context/SupportContext';

export default function() {
  return useContext(SupportContext);
}